// extracted by mini-css-extract-plugin
module.exports = {"Stats":"stats_Stats__34Qkm","Frequency":"stats_Frequency__2D4JC","CheckIcon":"stats_CheckIcon__1cjDM","CloseIcon":"stats_CloseIcon__3c70O"};